<template>
  <main class="mt-5">
    <BOverlay :show="loading" z-index="1050" rounded="lg" opacity="0.6">
      <div class="card">
        <div class="card-header border-0">
          <div class="card-title">گزارش فعالیت کاربران</div>
        </div>
        <div class="card-body">
          <div>
            <BForm @submit.prevent="submitHandler">
              <div class="row align-items-baseline">
                <BFormGroup class="col-12 col-md-3" label="شناسه کاربر">
                  <CustomerSearch
                    v-model="filter.user_id"
                    :allow-empty="true"
                    :show-label="false"
                  />
                </BFormGroup>
                <BFormGroup class="col-12 col-md-3" label="نوع فعالیت">
                  <multiselect
                    v-model="filter.type"
                    placeholder="انتخاب کنید"
                    :allow-empty="false"
                    open-direction="bottom"
                    :options="options"
                    label="label"
                    track-by="value"
                    :searchable="true"
                    :close-on-select="true"
                    :show-labels="false"
                    :disabled="disabled"
                  >
                    <template slot="noOptions">
                      موردی یافت نشد
                    </template>
                    <template slot="noResult">
                      موردی یافت نشد
                    </template>
                  </multiselect>
                </BFormGroup>
                <BButton type="submit" variant="primary">فیلتر</BButton>
              </div>
            </BForm>
          </div>
          <BTable
            v-if="items && items.data && items.data.length"
            bordered
            responsive
            striped
            :items="items.data"
            :fields="fields"
          >
            <template #cell(index)="data">
              {{ data.index + 1 }}
            </template>
            <template #cell(created_at)="data">
              {{ data.item.created_at | persianDate }}
            </template>
          </BTable>
          <div v-else class="alert alert-danger">موردی یافت نشد</div>
          <pagination
            v-if="items && items.data && items.data.length"
            :disabled="disabled"
            :limit="2"
            :data="items"
            @pagination-change-page="changePage"
          >
          </pagination>
        </div>
      </div>
    </BOverlay>
  </main>
</template>
<script>
import ActivityLogsImpl from "@@/core/pages/activityLogs/ActivityLogsImpl";
export default {
  extends: ActivityLogsImpl,
};
</script>
